import { render, staticRenderFns } from "./ProcessDetail.vue?vue&type=template&id=5b048428&"
import script from "./ProcessDetail.vue?vue&type=script&lang=js&"
export * from "./ProcessDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b048428')) {
      api.createRecord('5b048428', component.options)
    } else {
      api.reload('5b048428', component.options)
    }
    module.hot.accept("./ProcessDetail.vue?vue&type=template&id=5b048428&", function () {
      api.rerender('5b048428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/fast-tracking/ProcessDetail.vue"
export default component.exports